import { useEffect } from "react";
import type { Breadcrumb } from "@/components/AppHeader";
import { useBreadcrumbContext } from "@/layouts/AuthenticatedLayout";

/**
 * Hook for child pages to set breadcrumbs in the AuthenticatedLayout header.
 *
 * @example
 * // Simple static breadcrumbs
 * useSetBreadcrumbs([{ label: "Settings" }]);
 *
 * // Dynamic breadcrumbs with loading state
 * useSetBreadcrumbs([
 *   { label: className ?? "Class", to: `/classes/${classId}`, loading: isLoading },
 *   { label: "Assignment" },
 * ]);
 */
export function useSetBreadcrumbs(breadcrumbs: Breadcrumb[]) {
  const { setBreadcrumbs } = useBreadcrumbContext();

  useEffect(() => {
    setBreadcrumbs(breadcrumbs);
  }, [setBreadcrumbs, JSON.stringify(breadcrumbs)]);

  // Clear breadcrumbs on unmount
  useEffect(() => {
    return () => {
      setBreadcrumbs([]);
    };
  }, [setBreadcrumbs]);
}
